<template>
  <v-footer class="background-white" padless>
    <v-sheet class="mx-auto my-2">
      <v-row justify="center" no-gutters>
        <v-col>
          <external-link href="https://www.itscom.co.jp/info/privacy/" label="個人情報保護方針" />
        </v-col>
        <v-col>
          <external-link href="https://www.itscom.co.jp/info/privacy/cookie.html" label="アクセス情報の取り扱い" />
        </v-col>
      </v-row>
    </v-sheet>
  </v-footer>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import ExternalLink from '@/components/ExternalLink.vue';

@Component({ components: { ExternalLink } })
export default class FooterBar extends Vue {}
</script>

<style scoped>
.background-white {
  background-color: #fff !important;
}
</style>
